import { render, staticRenderFns } from "./xinjiangongdan.vue?vue&type=template&id=68f62dac&scoped=true"
import script from "./xinjiangongdan.vue?vue&type=script&lang=js"
export * from "./xinjiangongdan.vue?vue&type=script&lang=js"
import style0 from "./xinjiangongdan.vue?vue&type=style&index=0&id=68f62dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f62dac",
  null
  
)

export default component.exports